/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      gridGap: theme.spacing(1),
      justifyContent: 'center',
    },
    rootEmbedded: {
      marginBottom: theme.spacing(3),
    },
    selectorRoot: {
      minWidth: theme.spacing(12.5),
    },
    flagIcon: {
      width: theme.spacing(2),
      height: theme.spacing(2),
      borderRadius: '50%',
      objectFit: 'cover',
    },
    regionLabel: {
      lineHeight: '1.2',
    },
    menuItem: {
      minHeight: 'auto',
    },
  })
);

export default useStyles;
